import { _ } from '@ngx-translate/core';

import { FieldType, FieldTypeName } from './types';

export const FIELD_TYPES: Record<FieldTypeName, FieldType> = {
  // TODO: Типы которые нужно брать с бэка (нужно API)
  phone: {
    id: 1,
    description: _('components.field.constants.fieldTypes.phone'),
    forContacts: true,
  },
  email: {
    id: 2,
    description: 'Email',
    forContacts: true,
  },
  'web-page': {
    id: 3,
    description: _('components.field.constants.fieldTypes.webPage'),
    forContacts: true,
  },
  'web-document': {
    id: 4,
    description: _('components.field.constants.fieldTypes.webDocument'),
    forContacts: true,
  },
  'social-network': {
    id: 5,
    description: _('components.field.constants.fieldTypes.socialNetwork'),
    forContacts: true,
  },
  messenger: {
    id: 6,
    description: _('components.field.constants.fieldTypes.messenger'),
    forContacts: true,
  },
  file: {
    id: 8,
    description: _('components.field.constants.fieldTypes.file'),
    forContacts: true,
  },
  text: {
    id: 7,
    description: _('components.field.constants.fieldTypes.text'),
    forContacts: true,
  },
  'web-document-for-admin': {
    id: 11,
    description: _('components.field.constants.fieldTypes.webDocumentForAdmin'),
    forContacts: true,
    permissions: ['contactsTypeForAdminViewing'],
  },
  'file-for-admin': {
    id: 13,
    description: _('components.field.constants.fieldTypes.fileForAdmin'),
    forContacts: true,
    permissions: ['contactsTypeForAdminViewing'],
  },
  'text-for-admin': {
    id: 9,
    description: _('components.field.constants.fieldTypes.textForAdmin'),
    forContacts: true,
    permissions: ['contactsTypeForAdminViewing'],
  },
  'web-document-for-admin-and-user': {
    id: 12,
    description: _('components.field.constants.fieldTypes.webDocumentForAdminAndUser'),
    forContacts: true,
  },
  'file-for-admin-and-user': {
    id: 14,
    description: _('components.field.constants.fieldTypes.fileForAdminAndUser'),
    forContacts: true,
  },
  'text-for-admin-and-user': {
    id: 10,
    description: _('components.field.constants.fieldTypes.textForAdminAndUser'),
    forContacts: true,
  },
  list: {
    id: 15,
    description: _('components.field.constants.fieldTypes.list'),
    forContacts: true,
  },
  'list-for-admin': {
    id: 16,
    description: _('components.field.constants.fieldTypes.listForAdmin'),
    forContacts: true,
    permissions: ['contactsTypeForAdminViewing'],
  },
  'list-for-admin-and-user': {
    id: 17,
    description: _('components.field.constants.fieldTypes.listForAdminAndUser'),
    forContacts: true,
  },

  // Типы которые используются только на фронте
  user: {
    id: 100,
    description: _('components.field.constants.fieldTypes.user'),
    forContacts: false,
  },
  organisation: {
    id: 101,
    description: _('components.field.constants.fieldTypes.organisation'),
    forContacts: false,
  },
  'files-list': {
    id: 102,
    description: _('components.field.constants.fieldTypes.filesList'),
    forContacts: false,
  },
  'parse-links': {
    id: 103,
    description: _('components.field.constants.fieldTypes.text'),
    forContacts: false,
  },
  committee: {
    id: 104,
    description: _('components.field.constants.fieldTypes.committee'),
    forContacts: false,
  },
  'new-text': {
    id: 105,
    description: _('components.field.constants.fieldTypes.text'),
    forContacts: false,
  },
  'new-user': {
    id: 106,
    description: _('components.field.constants.fieldTypes.user'),
    forContacts: false,
  },
  'new-committee': {
    id: 107,
    description: _('components.field.constants.fieldTypes.committee'),
    forContacts: false,
  },
  'new-web-page': {
    id: 108,
    description: _('components.field.constants.fieldTypes.webPage'),
    forContacts: false,
  },
  'new-parse-links': {
    id: 109,
    description: _('components.field.constants.fieldTypes.text'),
    forContacts: false,
  },
};

export enum FieldTypes {
  Phone = 1,
  Email = 2,
  WebPage = 3,
  WebDocument = 4,
  SocialNetwork = 5,
  Messenger = 6,
  Text = 7,
  File = 8,
  TextForAdmin = 9,
  TextForAdminAndUser = 10,
  WebDocumentForAdmin = 11,
  WebDocumentForAdminAndUser = 12,
  FileForAdmin = 13,
  FileForAdminAndUser = 14,
  List = 15,
  ListForAdmin = 16,
  ListForAdminAndUser = 17,

  // Типы которые используются только на фронте
  User = 100,
  Organisation = 101,
  FilesList = 102,
  ParseLinks = 103,
  Committee = 104,
  NewText = 105,
  NewUser = 106,
  NewCommittee = 107,
  NewWebPage = 108,
  NewParseLinks = 109,
}
